<template>
  <BjDrawerForm ref="BjDrawerForm" class="view-container" :form="form" label-width="130px" width="850px"
    @handleConfirm="handleConfirm">
    <template>
      <BjDivider>{{ $t('BusinessPurchaseSupplierShop.dataForm.title') }}
        <template v-if="isEdit" #right>
          <el-button type="primary" @click="showLog">{{ $t('BusinessPurchaseSupplierShop.dataForm.titleBtn')
          }}</el-button>
        </template>
      </BjDivider>
      <el-row>
        <el-col :span="12">
          <BjFormItemCode v-model="channelData.code" disabled :label="$t('ChannelManagement.Main.code')" />
        </el-col>
        <el-col :span="12">
          <BjFormItemCode v-model="channelData.name" disabled :label="$t('ChannelManagement.Main.name')" />
        </el-col>
      </el-row>
      <BjDivider>{{ $t('BusinessPurchaseSupplierShop.dataForm.productInformation') }}
        <template #right>
          <el-button v-if="!isEdit" type="primary" @click="addGoodsDialog">{{
            $t('BusinessPurchaseSupplierShop.dataForm.addCommodity') }}</el-button>
        </template>
      </BjDivider>
      <el-table :data="form.skuList" border script>
        <el-table-column type="index" :label="$t('table.countText')" width="60" align="center" />
        <el-table-column prop="innerSkuCode" :label="$t('BusinessPurchaseSupplierShop.dataForm.sku')" align="center"></el-table-column>
        <el-table-column prop="skuCode" :label="$t('ChannelManagement.Main.innerSkuCode')" align="center" width="145">
          <template v-slot="{ row }">
            <BjInputCode v-if="!isEdit" v-model="row.skuCode" :disabled="isEdit" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            <template v-else>{{ row.skuCode }}</template>
          </template>
        </el-table-column>
        <el-table-column prop="price" :label="$t('ChannelManagement.Main.price')" align="center">
          <template v-slot="{ row }">
            <BjInputMoney v-model="row.price" :placeholder="$t('inputText')" clearable />
          </template>
        </el-table-column>
        <el-table-column prop="newPrice" :label="$t('ChannelManagement.Main.newPrice')" align="center">
          <template v-slot="{ row }">
            <BjInputMoney v-model="row.newPrice" :placeholder="$t('inputText')"
              clearable />
          </template>
        </el-table-column>
        <el-table-column prop="updatePriceTime" :label="$t('ChannelManagement.Main.updatePriceTime')" align="center" width="175">
          <template v-slot="{ row }">
            <el-date-picker v-model="row.updatePriceTime" class="full-width" type="date" :picker-options="pickerOptions"
            format="dd/MM/yyyy" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('chooseText')" />
          </template>
        </el-table-column>
      </el-table>
      <!-- 选择普通商品 -->
      <BjDialogList ref="dialogListSku" width="80%"
        :config="$BjDialogListConfig.skuDefault(this.$t('BusinessPurchaseSupplierShop.dataForm.addCommodity'), { defaultQuery: { setFlag: 0, status: [3, 4, 5] }, })"
        multiple @confirm="onAddGoodsDialogConfirm" />
    </template>
  </BjDrawerForm>
</template>
<script>
import { thirdApi } from '@/api';
import orderLog from '@/utils/log.js';
import BjInputMoney from '@/packages/BjInputMoney';
import BjInputCode from '@/packages/BjInputCode';

const getDefaultForm = () => {
  return {
    skuList: [],
  };
};

export default {
  components: {BjInputCode, BjInputMoney },
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      pickerOptions: {
        // 限制时间选择今天及以后的
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 3600 * 1000 * 24;
        },
      },
      channelData: this.$store.getters.storePriceControl
    };
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    onImport() {
      this.$refs.ExcelImport.show();
    },
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(
        this.isEdit
          ? this.$t('BusinessPurchaseSupplierShop.dataForm.edit')
          : this.$t('BusinessPurchaseSupplierShop.dataForm.add'),
      );
      if (this.isEdit) {
        this.form.skuList = [info];
      } else {
        this.form.skuList = [];
      }
    },
    showLog() {
      orderLog(
        this.$BjDialogListConfig['purchaseDefault'](
          `${this.$t('BusinessPurchaseSupplierShop.dataForm.supplier')} （${this.form.supplierCode
          }）${this.$t('BusinessPurchaseSupplierShop.dataForm.log')}`,
          {
            defaultQuery: {
              recordId: this.form.id,
              recordType: 'SUPPLER_GOODS',
            },
            search: [],
          },
        ),
      );
    },
    addGoodsDialog() {
      this.$refs['dialogListSku'].show(this.form.skuList);
    },
    // 商品回调
    onAddGoodsDialogConfirm(data) {
      data.forEach(item => {
        item.innerSkuCode = item.skuCode;
        item.skuCode = null;
      });
      this.form.skuList = data;
    },
    handleConfirm() {
      if (this.form.skuList.length === 0) {
        this.msgError(this.$t('BusinessPurchaseSupplierShop.dataForm.msgError'));
        return;
      }
      for (const item of Object.values(this.form.skuList)) {
        if (!item.skuCode) return this.$message.error(this.$t('ChannelManagement.Main.errorMsg1'));
        if (!item.price) {
          if (!item.newPrice || !item.updatePriceTime) {
            this.$message.error(this.$t('ChannelManagement.Main.errorMsg2'));
            return;
          }
        }
        if (item.newPrice) {
          if (!item.updatePriceTime) {
            this.$message.error(this.$t('ChannelManagement.Main.errorMsg3'));
            return;
          }
        }
        if (item.updatePriceTime) {
          if (!item.newPrice) {
            this.$message.error(this.$t('ChannelManagement.Main.errorMsg3'));
            return;
          }
        }
        if (!item.price && !item.newPrice && !item.updatePriceTime) {
          this.$message.error(this.$t('ChannelManagement.Main.errorMsg4'));
          return;
        }
      }

      const API_DATA = this.$lodash.clone(this.form);
      if (!this.isEdit) {
        API_DATA.skuList = API_DATA.skuList.map(e => {
          return {
            channelCode: this.channelData.channelTypeCode,
            storeId: this.channelData.id,
            storeCode: this.channelData.code,
            storeName: this.channelData.channelWarehouseName,
            channelName: this.channelData.channelTypeMeaning,
            skuCode: e.skuCode,
            innerSkuCode: e.innerSkuCode,
            price: e.price,
            status: 1,
            newPrice: e.newPrice,
            updatePriceTime: e.updatePriceTime
          };
        });
        this.sendApi(API_DATA.skuList);
      } else {
        this.sendApi(API_DATA.skuList[0]);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    sendApi(API_DATA) {
      thirdApi[(this.isEdit ? 'put' : 'add') + 'ThirdPartyGoods'](API_DATA).then(res => {
        if (res.failed === false || res._token) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
